import { configureStore, combineReducers } from "@reduxjs/toolkit";
import userReducer from "./userSlice";
import columnsReducer from "./columnsSlice";
import expenseRatioFilterReducer from "./expenseRatioFilterSlice";
import pnlFilterReducer from "./pnlFilterSlice";
import cashflowFilterReducer from "./cashflowFilterSlice";
import ownerReportFilterReducer from "./ownerReportFilterSlice";
import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from "redux-persist";
import storage from "redux-persist/lib/storage";
import { rootMigrate } from "./persistMigrations";

const persistConfig = {
  key: "root",
  version: 8,
  storage,
  migrate: rootMigrate,
};

const rootReducer = combineReducers({
  user: userReducer,
  columns: columnsReducer,
  expenseRatioFilter: expenseRatioFilterReducer,
  pnlFilter: pnlFilterReducer,
  cashflowFilter: cashflowFilterReducer,
  ownerReportFilter: ownerReportFilterReducer,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});

export let persistor;

if (typeof window !== "undefined") {
  persistor = persistStore(store);
}
